import { Component } from "@angular/core"
import { Router } from "@angular/router";

import { SessionService } from "src/app/services/session.service"
import { toastrService } from "src/app/services/ux/toastr.service"
import { Client } from "src/app/services/API/client"
import { TranslateService } from "@ngx-translate/core"

@Component({
  templateUrl: "./create-message.component.html",
  styleUrls: ["./create-message.component.css"]
})

export class CreateMessageComponent {
  loading: boolean = false
  subject: string = ""
  body: string = ""

  constructor(
    public toastr: toastrService, 
    private session: SessionService,
    private api: Client,
    private translateService: TranslateService,
    private router: Router
  ) {}

  async sendMessage() {
    if (!this.session.isLoggedIn()) return

    if (!this.subject || !this.subject.trim() || !this.body || !this.body.trim()) {
      this.toastr.error(this.translateService.instant("Message.FillInSubjectAndBody"))
      return
    }

    this.loading = true
    try {
      await this.api.post("api/message/createMessage", { subject: this.subject, body: this.body })
      this.router.navigateByUrl("/messages")
    } catch(err) {
      this.toastr.error(err.message)
    }
    this.loading = false
  }
}